import React, { useEffect, useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import { Button, Col, Row } from "react-bootstrap";
import Loading from "../components/loading/Loading";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import UploadIMG from "../components/uploads/UploadIMG";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import Text from '../components/inputTxt/Text';
import { createAndUpdateJob, getDataJobAll } from "../api/job_api"
import {
    alertValidateData,
    alertOverLimit,
    alertConfirmSave,
    alertSaved,
    alertCancel,
} from "../components/alertValid/AlertValid.js"
import CustomCKEditor from '../components/ckEditor/CustomCKEditor.js';

function ContentCareer() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);

    const [editId, setEditId] = useState(null);
    const [txtEnDescValue, setTxtEnDescValue] = useState('');
    const [txtThDescValue, setTxtThDescValue] = useState('');
    const [txtEnBenefitValue, setTxtEnBenefitValue] = useState('');
    const [txtThBenefitValue, setTxtThBenefitValue] = useState('');
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [images2, setImages2] = useState([]);
    const [imagesFromApi2, setImagesFromApi2] = useState([]);
    const [images3, setImages3] = useState([]);
    const [imagesFromApi3, setImagesFromApi3] = useState([]);
    const [images4, setImages4] = useState([]);
    const [imagesFromApi4, setImagesFromApi4] = useState([]);

    const [dataDetail, setDataDetail] = useState([
        {
            eng: { title: 'testTitleEn1' },
            tha: { title: 'testTitleTh1' }
        },
    ]);

    const handleChangeInpEnBenefit = async (index, newValue) => {
        // Trim newValue to 50 characters
        const trimmedValue = newValue.substring(0, 50);
        const newDataDetail = [...dataDetail]; // Create a copy of the dataDetail array
        newDataDetail[index].eng.title = trimmedValue; // Update the Thai title of the specified index
        if (newValue?.length > 50) {
            const result = await alertOverLimit();
                if (result.isConfirmed) {
                    setDataDetail(newDataDetail); // Update the state with the modified array
                }
                else {
                    setDataDetail(newDataDetail);
                }            
        }
        else {
            setDataDetail(newDataDetail); // Update the state with the modified array
        }
    };

    const handleChangeInpThBenefit = async (index, newValue) => {
        // Trim newValue to 50 characters
        const trimmedValue = newValue.substring(0, 50);
        const newDataDetail = [...dataDetail]; // Create a copy of the dataDetail array
        newDataDetail[index].tha.title = trimmedValue; // Update the Thai title of the specified index
        setDataDetail(newDataDetail);
        if (newValue?.length > 50) {
            const result = await alertOverLimit();
                if (result.isConfirmed) {
                    setDataDetail(newDataDetail); // Update the state with the modified array
                }
                else {
                    setDataDetail(newDataDetail);
                }
        }
        else {
            setDataDetail(newDataDetail); // Update the state with the modified array
        }
    };
        // Function to add an object to dataDetail array
        const addObjectToArray = () => {
            const newDataDetail = [...dataDetail, {
                eng: { title: '' },
                tha: { title: '' }
            }];
            setDataDetail(newDataDetail);
        };
    
        // Function to remove the last object from dataDetail array
        const removeObjectFromArray = () => {
            const newDataDetail = dataDetail.slice(0, -1); // Remove the last element
            setDataDetail(newDataDetail);
        };

        const handleSelectedImages1 = (images) => {
            setImages1(images);
        };
        const handleSelectedRemoveImg1 = (data) => {
            // setDataStClear(data);
            setImages1(data);
        };
    
        const handleSelectedImages2 = (images) => {
            setImages2(images);
        };
        const handleSelectedRemoveImg2 = (data) => {
            // setDataStClear(data);
            setImages2(data);
        };

        const handleSelectedImages3 = (images) => {
            setImages3(images);
        };
        const handleSelectedRemoveImg3 = (data) => {
            // setDataStClear(data);
            setImages3(data);
        };

        const handleSelectedImages4 = (images) => {
            setImages4(images);
        };
        const handleSelectedRemoveImg4 = (data) => {
            // setDataStClear(data);
            setImages4(data);
        };

        const navigate = useNavigate();
        const navigateToBack = (page) => {
            navigate(page);
        };

        const alertValidate = async () => {
            const result = await alertValidateData();
                if (result.isConfirmed) {
                    return;
                } else {
                    return;
                }
        }

        const handleClickCancel = async () => {
            const res = await alertCancel();
                    if (res.isConfirmed) {
                        navigateToBack("/infoContentCareer");
                    }
                    else { }
        };

        const handleSaveBtn = async () => {

            if (editId) {

                const formatedBodyToServer = {
                    corevalue_en: txtEnDescValue,
                    corevalue_th: txtThDescValue,
                    welfare_en: txtEnBenefitValue,
                    welfare_th: txtThBenefitValue,
                    welfare_list: dataDetail.map((item) => {
                        return {
                            name_en: item.eng.title,
                            name_th: item.tha.title
                        }
                    }),
                    image_creatively: images1 ?? null,
                    image_responsively: images2 ?? null,
                    image_passionately: images3 ?? null,
                    image_accountably: images4 ?? null,
                }
                if (
                    !formatedBodyToServer.corevalue_en ||
                    !formatedBodyToServer.corevalue_th ||
                    !formatedBodyToServer.welfare_en ||
                    !formatedBodyToServer.welfare_th ||
                    formatedBodyToServer.welfare_list.some(x=> !x.name_en) ||
                    formatedBodyToServer.welfare_list.some(x=> !x.name_th) ||
                    !formatedBodyToServer.image_creatively.length > 0 ||
                    !formatedBodyToServer.image_responsively.length > 0 ||
                    !formatedBodyToServer.image_passionately.length > 0 ||
                    !formatedBodyToServer.image_accountably.length > 0
                ) {
                  await alertValidate();
                } else {
                    const result = await alertConfirmSave();
                    if (result.isConfirmed) {
                      (async () => {
                        await setLoading(true);
                        const response = await createAndUpdateJob(formatedBodyToServer)
                        setLoading(false)
                          if (response.status == "success") {
                            const res = await alertSaved();
                              if (res.isConfirmed) {
                                window.location.reload();
                              }
                          }
                      })();
                    }
            }
        } else {
                const formatedBodyToServer = {
                    corevalue_en: txtEnDescValue,
                    corevalue_th: txtThDescValue,
                    welfare_en: txtEnBenefitValue,
                    welfare_th: txtThBenefitValue,
                    welfare_list: dataDetail.map((item) => {
                        return {
                            name_en: item.eng.title,
                            name_th: item.tha.title
                        }
                    }),
                    image_creatively: images1 ?? null,
                    image_responsively: images2 ?? null,
                    image_passionately: images3 ?? null,
                    image_accountably: images4 ?? null,
                }
                if (
                    !formatedBodyToServer.corevalue_en ||
                    !formatedBodyToServer.corevalue_th ||
                    !formatedBodyToServer.welfare_en ||
                    !formatedBodyToServer.welfare_th ||
                    formatedBodyToServer.welfare_list.some(x=> !x.name_en) ||
                    formatedBodyToServer.welfare_list.some(x=> !x.name_th) ||
                    !formatedBodyToServer.image_creatively.length > 0 ||
                    !formatedBodyToServer.image_responsively.length > 0 ||
                    !formatedBodyToServer.image_passionately.length > 0 ||
                    !formatedBodyToServer.image_accountably.length > 0
                ) {
                  await alertValidate();
                } else {
                    const result = await alertConfirmSave();
                    if (result.isConfirmed) {
                      (async () => {
                        await setLoading(true);
                        const response = await createAndUpdateJob(formatedBodyToServer)
                        setLoading(false)
                          if (response.status == "success") {
                            const res = await alertSaved();
                              if (res.isConfirmed) {
                                window.location.reload();
                              }
                          }
                      })();
                    }
            }
            }
        };
        async function urlToBlob(url) {
            // Fetch the image data from the URL
            const response = await fetch(url);
        
            // Convert the fetched image data to Blob
            const blob = await response.blob();
        
            return blob;
        }
        const getList = async () => {
            try {
                const response = await getDataJobAll();
                setEditId(response?.data?.data?._id)
                setTxtEnDescValue(response?.data?.data?.corevalue_en)
                setTxtThDescValue(response?.data?.data?.corevalue_th)
                setTxtEnBenefitValue(response?.data?.data?.welfare_en)
                setTxtThBenefitValue(response?.data?.data?.welfare_th)
                // ################## welfare list #####################33
                if(response?.data?.data?.welfare_list && response?.data?.data?.welfare_list.length>0){
                    const rawDetailList = response?.data?.data?.welfare_list.map((item) => {
                        return {
                            eng: { title: item?.name_en??'' },
                            tha: { title: item?.name_th??'' }
                        }
                    })
                    setDataDetail(rawDetailList)
                }
                
                setImagesFromApi1([{
                    id: 0,
                    status: false,
                    src:
                        response?.data?.data?.image_creatively === null ||
                        response?.data?.data?.image_creatively === ""
                        ? ''
                        : response?.data?.data?.image_creatively,
                    file: response?.data?.data?.image_creatively ? await urlToBlob(response?.data?.data?.image_creatively) : null,
                    size: 1024*1024*4, //hard code ให้ผ่าน validate 
                    type:'image/jpg' //hard code ให้ผ่าน validate
                }])
                setImagesFromApi2([{
                    id: 0,
                    status: false,
                    src:
                        response?.data?.data?.image_responsively === null ||
                        response?.data?.data?.image_responsively === ""
                        ? ''
                        : response?.data?.data?.image_responsively,
                    file: response?.data?.data?.image_responsively ? await urlToBlob(response?.data?.data?.image_responsively) : null,
                    size: 1024*1024*4, //hard code ให้ผ่าน validate 
                    type:'image/jpg' //hard code ให้ผ่าน validate
                }])
                setImagesFromApi3([{
                    id: 0,
                    status: false,
                    src:
                        response?.data?.data?.image_passionately === null ||
                        response?.data?.data?.image_passionately === ""
                        ? ''
                        : response?.data?.data?.image_passionately,
                    file: response?.data?.data?.image_passionately ? await urlToBlob(response?.data?.data?.image_passionately) : null,
                    size: 1024*1024*4, //hard code ให้ผ่าน validate 
                    type:'image/jpg' //hard code ให้ผ่าน validate
                }])
                setImagesFromApi4([{
                    id: 0,
                        status: false,
                        src:
                            response?.data?.data?.image_accountably === null ||
                            response?.data?.data?.image_accountably === ""
                            ? ''
                            : response?.data?.data?.image_accountably,
                    file: response?.data?.data?.image_accountably ? await urlToBlob(response?.data?.data?.image_accountably) : null,
                    size: 1024*1024*4, //hard code ให้ผ่าน validate 
                    type:'image/jpg' //hard code ให้ผ่าน validate
                }])
            } catch (error) {
                console.log(error.message);
            }
        };
    useEffect(() => {
        getList()
    }, [])
  return (
    <>
        {isLoading ? <Loading /> : ""}
        <style>
                {`
                    .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                        height: 200px;
                    }
                `}
        </style>
        <Header parentmenu={"CAREER JOB"} />
        <Menu
            parentmenu={"infoCareerJob"}
            activemenu={"infoContentCareer"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-careers.png" className="ic-user01 me-2" alt="" />
                                CAREER JOB<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> CONTENT CAREER
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    CORE VALUES <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    ค่านิยมหลัก <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDescValue}
                                    onChange={(newData) => {
                                        setTxtEnDescValue(newData);
                                    }}
                                    placeholder="Description"
                                />
                            </Col>
                            <Col xs={6}>   
                                <CustomCKEditor
                                    data={txtThDescValue}
                                    onChange={(newData) => {
                                        setTxtThDescValue(newData);
                                    }}
                                    placeholder="คำอธิบาย / คอลัมน์"
                                /> 
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    WELFARE BENEFIT <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    สวัสดิการ <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}> 
                                <CustomCKEditor
                                    data={txtEnBenefitValue}
                                    onChange={(newData) => {
                                        setTxtEnBenefitValue(newData);
                                    }}
                                    placeholder="Description"
                                />   
                            </Col>
                            <Col xs={6}>    
                                <CustomCKEditor
                                    data={txtThBenefitValue}
                                    onChange={(newData) => {
                                        setTxtThBenefitValue(newData);
                                    }}
                                    placeholder="คำอธิบาย / คอลัมน์"
                                /> 
                            </Col>
                        </Row>
                        {dataDetail.map((data, index) => (
                            <div key={index}>
                                <Row className='mt-2'>
                                    <Col xs={6}>
                                        <div className='d-flex justify-content-between'>
                                            <img src="assets/icons/ic-benefit.png" className="sty-ic01 me-2" alt="" />
                                            <Text
                                                value={data.eng.title}
                                                onChange={(e) => handleChangeInpEnBenefit(index, e.target.value)}
                                                placeholder="Text"
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={6}>
                                        <div className='d-flex justify-content-between'>
                                            <img src="assets/icons/ic-benefit.png" className="sty-ic01 me-2" alt="" />
                                            <Text
                                                value={data.tha.title}
                                                onChange={(e) => handleChangeInpThBenefit(index, e.target.value)}
                                                placeholder="คำอธิบาย / คอลัมน์"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        ))}
                        <Row>
                            <Col xs={12} className='d-flex justify-content-end'>
                                <div className='d-flex justify-content-between me-5'>
                                    <Button className='btn-none' onClick={addObjectToArray}>
                                        <img src="assets/icons/btn-add.png" className="sty-ic02 me-2" alt="" />
                                    </Button>
                                    <Button className='btn-none' onClick={removeObjectFromArray}>
                                        <img src="assets/icons/btn-delete.png" className="sty-ic02 me-2" alt="" />
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <Row>
                        <Col xs={6}>
                            <font className="font-size01 colorBlack01 fontBold">
                                Image CREATIVELY UNCONVENTIONAL <span className=' colorRed'>*</span>
                            </font>
                        </Col>
                        <Col xs={6}>
                            <font className="font-size01 colorBlack01 fontBold">
                                Image RESPONSIVELY CUSTOMER-CENTRIC <span className=' colorRed'>*</span>
                            </font>
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col xs={6}>
                            <UploadIMG
                                limit={1}
                                onSelectedImages={handleSelectedImages1}
                                images={imagesFromApi1}
                                txtDetail={"jpg. / 480x300 px , limit size 5MB"}
                                removeImg={handleSelectedRemoveImg1}
                            />
                        </Col>
                        <Col xs={6}>
                            <UploadIMG
                                limit={1}
                                onSelectedImages={handleSelectedImages2}
                                images={imagesFromApi2}
                                txtDetail={"jpg. / 480x300 px , limit size 5MB"}
                                removeImg={handleSelectedRemoveImg2}
                            />
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col xs={6}>
                            <font className="font-size01 colorBlack01 fontBold">
                                Image PASSIONATELY REFINED <span className=' colorRed'>*</span>
                            </font>
                        </Col>
                        <Col xs={6}>
                            <font className="font-size01 colorBlack01 fontBold">
                                Image ACCOUNTABLY COMMITTED <span className=' colorRed'>*</span>
                            </font>
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col xs={6}>
                            <UploadIMG
                                limit={1}
                                onSelectedImages={handleSelectedImages3}
                                images={imagesFromApi3}
                                txtDetail={"jpg. / 480x300 px , limit size 5MB"}
                                removeImg={handleSelectedRemoveImg3}
                            />
                        </Col>
                        <Col xs={6}>
                            <UploadIMG
                                limit={1}
                                onSelectedImages={handleSelectedImages4}
                                images={imagesFromApi4}
                                txtDetail={"jpg. / 480x300 px , limit size 5MB"}
                                removeImg={handleSelectedRemoveImg4}
                            />
                        </Col>
                    </Row>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                        <button
                            className="btn-cancle01"
                            onClick={() => handleClickCancel()}
                        >
                            CANCEL
                        </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                        <button
                            className="btn-save01"
                            onClick={(e) => {
                                handleSaveBtn();
                            }}
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default ContentCareer;